import { useState, useEffect, useRef } from "react";
import { supabase } from "../lib/supabase";

const getSessionId = () => {
  let id = sessionStorage.getItem("visitor_session_id");
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem("visitor_session_id", id);
  }
  return id;
};

export default function LiveVisitorCounter({ slug = "blog" }) {
  const [visitors, setVisitors] = useState(null);
  const [pulse, setPulse] = useState(false);
  const sessionId = useRef(getSessionId());

  useEffect(() => {
    const session = sessionId.current;

    const register = async () => {
      await supabase.from("page_visitors").upsert(
        {
          page_slug: slug,
          session_id: session,
          last_seen: new Date().toISOString(),
        },
        { onConflict: "page_slug,session_id" }
      );
    };

    const fetchCount = async () => {
      await supabase.rpc("cleanup_old_visitors");
      const { count } = await supabase
        .from("page_visitors")
        .select("*", { count: "exact", head: true })
        .eq("page_slug", slug);
      setVisitors(count ?? 0);
      setPulse(true);
      setTimeout(() => setPulse(false), 600);
    };

    const unregister = async () => {
      await supabase
        .from("page_visitors")
        .delete()
        .match({ page_slug: slug, session_id: session });
    };

    register().then(fetchCount);

    const heartbeat = setInterval(() => {
      register().then(fetchCount);
    }, 20000);

    window.addEventListener("beforeunload", unregister);

    return () => {
      clearInterval(heartbeat);
      window.removeEventListener("beforeunload", unregister);
      unregister();
    };
  }, [slug]);

  return (
    <div style={styles.wrapper}>
      <span style={{ ...styles.dot, ...(pulse ? styles.dotPulse : {}) }} />
      <span style={styles.label}>
        {visitors === null ? (
          "Connecting…"
        ) : (
          <>
            <strong style={styles.count}>{visitors}</strong>{" "}
            {visitors === 1 ? "person" : "people"} reading now
          </>
        )}
      </span>
    </div>
  );
}

const styles = {
  wrapper: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 14px",
    borderRadius: "999px",
    background: "#f0fdf4",
    border: "1px solid #314f2d",
    fontSize: "0.875rem",
    color: "#314f2d",
    fontFamily: "inherit",
    userSelect: "none",
  },
  dot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: "#314f2d",
    flexShrink: 0,
    transition: "transform 0.3s ease, opacity 0.3s ease",
  },
  dotPulse: { transform: "scale(1.5)", opacity: 0.6 },
  label: { lineHeight: 1 },
  count: { fontWeight: 700 },
};